module.exports = __webpack_public_path__ + "img/project1_main.53f085ea.jpg";